import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import {
  APPROVED,
  RECOMMENDED_FOR_APPROVAL,
  REJECTED,
  SUBMITTED,
} from "../../utils/constants";
import {
  createSelectItem,
  createViewEdit,
  displayDocuments,
  formatDate,
  numberFormat,
} from "../../utils/helpers";
import { sourceApis } from "../handlers/useApiHandler";

export const useOtherIncome = () => {
  const tableColumns = (): TTableColumn[] => [
    { id: "income_date", header: "Income Date" },
    { id: "income_type_name", header: "Income Type" },
    { id: "full_name", header: "Source Name" },
    { id: "is_recurring", header: "Is Recurring" },
    { id: "payment_method", header: "Payment Method" },
    { id: "income_amount", header: "Amount" },
    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any) =>
    data.map((item: any) => ({
      ...item,
      income_date: formatDate(item?.income_date),
      income_amount: numberFormat(item?.income_amount),
      is_recurring: item?.is_recurring ? "Yes" : "No",
      full_name: `${item?.first_name} ${item?.last_name || ""} ${item?.other_name}`,
      actions: (
        <FormActions actions={createViewEdit("/other_income", item?.id)} />
      ),
    }));

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Income Information",
          fields: {
            income_date: formatDate(item?.income_date),
            income_type: item?.income_type_name,
            description: item?.description,
            is_recurring: item?.is_recurring ? "Yes" : "No",
            recurring_frequency: item?.recurring_income_frequency,
            payment_method: item?.payment_method,
            accounting: item?.accounting,
            amount: numberFormat(item?.income_amount),
            status: item?.status,
            created_at: formatDate(item?.created_at),
            updated_at: formatDate(item?.updated_at),
          },
        },
        {
          title: "Source Information",
          fields: {
            first_name: item?.first_name,
            last_name: item?.last_name,
            other_name: item?.other_name,
            phone_number: item?.phone_number,
            email: item?.email,
            organization: item?.organization_name,
          },
        },
        {
          title: "Supporting Documents",
          fields: displayDocuments(item?.other_income_attachments),
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData };
};

export function useOtherIncomeActions({ form, data }) {
  let actionsList = [RECOMMENDED_FOR_APPROVAL, APPROVED, REJECTED];

  if (data?.status === SUBMITTED) {
    actionsList = [RECOMMENDED_FOR_APPROVAL, REJECTED];
  } else if (data?.status === RECOMMENDED_FOR_APPROVAL) {
    actionsList = [APPROVED, REJECTED];
  }

  const actions = [...actionsList.map((action) => createSelectItem(action))];

  const fields = [
    {
      field_name: "status",
      type: "select",
      props: { required: true },
      options_data: actions,
      visible: data?.status !== APPROVED,
    },
    {
      field_name: "comment",
      label: "comment",
      type: "textarea",
    },
  ];

  function onSubmit(payload: any, id: any) {
    if (id) {
      let api = sourceApis["expenses"];

      if (!api) return;
      return {
        id,
        api,
        params: { ...payload },
      };
    }
  }
  const enableSubmit = Object.keys(form).length > 0;
  const finalStates = [APPROVED, REJECTED];

  return { fields, onSubmit, enableSubmit, finalStates };
}
